type OmitNulls<T> = {
  [K in keyof T]: Exclude<T[K], null>;
};

export function omitNulls<T extends object>(value: T | null | undefined): OmitNulls<T> {
  if (value == null) {
    return {} as OmitNulls<T>;
  }

  return Object.fromEntries(
    Object.entries(value).filter(([, entry]) => entry !== null)
  ) as OmitNulls<T>;
}
